import Konva from "konva";
import { DMCImage } from "../KObjects/DMCImage";

// TOOLS
const rectangleTool = require("./RectangleTool");

export class Picture extends rectangleTool.Rectangle {
  constructor() {
    super();
    this.currentMousePosDown = "";
    this.name = "Image";
    this.imagesSource = [];
    this.realSource = [];
    this.ratioImage = [];
  }

  createControllerObject(name, konvaObject) {
    return new DMCImage(name, konvaObject, this.realSource, this.ratioImage);
  }

  createNew(controllerProject) {
    super.createNew(controllerProject);
    this.currentObject.fill(null);
    this.currentObject.strokeWidth(0);
  }

  createTransformer(elementToTransform) {
    const transformer = super.createTransformer(elementToTransform);
    transformer.keepRatio(true);
    return transformer;
  }

  /**
   * @function createNewForm()
   * @description Called after mouseDown of the area draw
   */
  createNewForm() {
    let currentImage = new Image();
    currentImage.src = this.imagesSource[0];
    this.currentShapeConfig.image = currentImage;
    this.getRatio(currentImage);
    return new Konva.Image(this.currentShapeConfig);
  }

  /**
   * @function gcd(a,b)
   * @description Greatest common divisor (PGCD in french) between two number a & b
   */
  gcd(a, b) {
    return b == 0 ? a : this.gcd(b, a % b);
  }

  /**
   * @function getRatio(currentImage)
   * @description Get the ratio of the first image
   */
  getRatio(currentImage) {
    this.ratio = "16:10";

    // Try to get size of the current image to define correct ratio
    const poll = setInterval(() => {
      // When the size is retrieved
      if (currentImage.naturalWidth) {
        // Stop interval from seeking size
        clearInterval(poll);
        const gcd = this.gcd(currentImage.width, currentImage.height);
        this.ratio = currentImage.width / gcd + ":" + currentImage.height / gcd;
      }
    }, 10);
  }

  image(listPath, name) {
    this.name = name;
    this.imagesSource = [];
    this.realSource = [];

    listPath.forEach((path) => {
      this.imagesSource.push(path.replace("public\\", ""));
      this.realSource.push(path);
    });
  }

  mouseDown(controllerProject) {
    this.currentMousePosDown = controllerProject.collectCurrentMousePosition();
    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;
    const imageWidth = this.currentShapeConfig.image.width;
    const imageHeight = this.currentShapeConfig.image.height;

    if (!this.interval) {
      this.interval = setInterval(() => {
        const firstRatio = this.ratio.split(":")[0];
        const secondRatio = this.ratio.split(":")[1];
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale);
        const distanceY = Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale);

        if (distanceX / imageWidth > distanceY / imageHeight) {
          this.currentObject.setAttr("height", distanceY);
          this.currentObject.setAttr("width", (distanceY * firstRatio) / secondRatio);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", (distanceX * secondRatio) / firstRatio);
        }

        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", this.origin.x - this.currentObject.attrs.width);
        }

        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", this.origin.y - this.currentObject.attrs.height);
        }

        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 50);
    }
  }

  setContent(listPath, name) {
    this.image(listPath, name);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.currentObject.setAttr("rotation", this.edit.rotation);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }
}
